const IMPORT_TYPES = ["First Run", "Reprep 1", "Reprep 2", "OoS 1", "OoS 2"];

export default IMPORT_TYPES;
